<template>
  <div class="home">
    <OrderHistoryPage />
  </div>
</template>

<script>
import OrderHistoryPage from '../components/elements/pages/OrderHistoryPage.vue'
export default {
  name: 'OrderHistory',
  metaInfo: {
    title: 'Order History'
  },
  components: {
    OrderHistoryPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
